<template>
  <div>
    <div class="alert-info-cotizador"><i class="bi bi-info-circle me-1"></i> Servicio Prime: aplica un adicional de <strong>S/ 60.91</strong> para atención prioritaria.</div>

    <div class="seccion-titulo"><i class="bi bi-geo-alt me-2"></i>Destino</div>
    <div class="row g-3 mb-4">
      <div class="col-md-4">
        <label class="form-label form-label-sm">Departamento</label>
        <select class="form-select form-select-sm" v-model="destino.departamento_id" @change="cargarProvincias">
          <option value="" disabled>Seleccione</option>
          <option v-for="item in departamentos" :key="item.id" :value="item.id">{{ item.nombre }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label form-label-sm">Provincia</label>
        <select class="form-select form-select-sm" v-model="destino.provincia_id" @change="cargarDistritos">
          <option value="" disabled>Seleccione</option>
          <option v-for="item in provincias" :key="item.id" :value="item.id">{{ item.nombre }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label form-label-sm">Distrito</label>
        <select class="form-select form-select-sm" v-model="destino.distrito_id" @change="getPrecio()">
          <option value="" disabled>Seleccione</option>
          <option v-for="item in distritos" :key="item.id" :value="item.id">{{ item.nombre }}</option>
        </select>
      </div>
    </div>

    <div class="seccion-titulo"><i class="bi bi-calendar3 me-2"></i>Fechas y Tarifa</div>
    <div class="row g-3 mb-4">
      <div class="col-md-3">
        <label class="form-label form-label-sm">Fecha de salida</label>
        <input type="date" class="form-control form-control-sm" v-model="salida" @change="calcularFechaLlegada()" />
      </div>
      <div class="col-md-3">
        <label class="form-label form-label-sm">Fecha de entrega (aprox.)</label>
        <input type="date" class="form-control form-control-sm" readonly v-model="entrega" />
      </div>
      <div class="col-md-3">
        <label class="form-label form-label-sm">Lead Time (días)</label>
        <input type="number" class="form-control form-control-sm" :value="leadTime" disabled />
      </div>
      <div class="col-md-3">
        <label class="form-label form-label-sm">Tarifa (S/ por kg)</label>
        <input type="number" class="form-control form-control-sm" readonly v-model.number="tarifa" step="0.01" @input="calcularPrecio" />
      </div>
    </div>

    <div class="seccion-titulo"><i class="bi bi-box-seam me-2"></i>Dimensiones y Peso</div>
    <div class="row g-3 mb-4">
      <div class="col-6 col-md-2">
        <label class="form-label form-label-sm">Largo (cm)</label>
        <input type="number" class="form-control form-control-sm" v-model.number="largo" @input="calcularPesoVol" />
      </div>
      <div class="col-6 col-md-2">
        <label class="form-label form-label-sm">Ancho (cm)</label>
        <input type="number" class="form-control form-control-sm" v-model.number="ancho" @input="calcularPesoVol" />
      </div>
      <div class="col-6 col-md-2">
        <label class="form-label form-label-sm">Alto (cm)</label>
        <input type="number" class="form-control form-control-sm" v-model.number="alto" @input="calcularPesoVol" />
      </div>
      <div class="col-6 col-md-2">
        <label class="form-label form-label-sm">Peso real (kg)</label>
        <input type="number" class="form-control form-control-sm" v-model.number="peso" @input="calcularPrecio" />
      </div>
      <div class="col-6 col-md-2">
        <label class="form-label form-label-sm">Peso volumétrico (kg)</label>
        <input type="number" class="form-control form-control-sm" :value="pesoVol" disabled />
      </div>
    </div>

    <div v-if="precio_final" class="resultado-card">
      <div class="resultado-row">
        <span class="resultado-label"><i class="bi bi-calculator me-1"></i>Precio estimado</span>
        <span class="resultado-valor text-muted">S/ {{ precio }}</span>
      </div>
      <div class="resultado-row resultado-final">
        <span class="resultado-label"><i class="bi bi-check-circle-fill me-1"></i>Precio final (sin IGV)</span>
        <span class="resultado-precio">S/ {{ precio_final }}</span>
      </div>
      <div class="resultado-nota">* Mínimo de facturación aplicado si el estimado es menor al mínimo.</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: 'ConsolidadoAereo',
  data() {
    return {
      departamentos: [], provincias: [], distritos: [],
      destino: { departamento_id: '', provincia_id: '', distrito_id: '' },
      salida: '', entrega: '', leadTime: 0, tarifa: 0,
      largo: 0, ancho: 0, alto: 0, peso: 0, pesoVol: 0,
      precio: 0, precio_final: 0
    };
  },
  mounted() { this.cargarDepartamentos(); },
  methods: {
    async cargarDepartamentos() {
      try { const res = await axios.get('/departamentos'); this.departamentos = res.data; this.provincias = []; this.distritos = []; this.destino.provincia_id = ''; this.destino.distrito_id = ''; }
      catch (e) { console.error(e); }
    },
    async cargarProvincias() {
      try { this.distritos = []; const res = await axios.get('/provinciasByDepartamentos/' + this.destino.departamento_id); this.provincias = res.data; this.destino.provincia_id = ''; this.destino.distrito_id = ''; }
      catch (e) { console.error(e); }
    },
    async cargarDistritos() {
      try { const res = await axios.get('/distritosByProvincias/' + this.destino.provincia_id); this.distritos = res.data; this.destino.distrito_id = ''; }
      catch (e) { console.error(e); }
    },
    async getPrecio() {
      try {
        const { data } = await axios.get(`precio-consolidado-aereo/peso_volumen/${this.destino.distrito_id}`);
        let lt = data.lead_time;
        let dias = lt.includes('hora') ? parseInt(lt) / 24 : parseInt(lt);
        this.leadTime = dias; this.tarifa = data.costo;
        if (this.salida) this.calcularFechaLlegada();
      } catch (e) {
        if (e.response?.status === 404) { this.tarifa = 0; Swal.fire({ icon: 'warning', title: 'Sin cobertura', text: 'No hay cobertura para el destino seleccionado.' }); }
        else Swal.fire({ icon: 'error', title: 'Error', text: 'Ocurrió un problema al consultar el precio.' });
      }
    },
    calcularFechaLlegada() {
      const llegada = new Date(new Date(this.salida).getTime() + parseInt(this.leadTime) * 86400000);
      this.entrega = llegada.toISOString().slice(0, 10);
    },
    calcularPesoVol() {
      this.pesoVol = ((this.largo * this.ancho * this.alto) / 5000).toFixed(2);
      this.calcularPrecio();
    },
    calcularPrecio() {
      const pesoCobrado = Math.max(this.peso, this.pesoVol);
      this.precio = (pesoCobrado * this.tarifa).toFixed(2);
      this.precio_final = this.precio < 203.02 ? 203.02 : this.precio;
    }
  }
};
</script>

<style scoped>
.alert-info-cotizador { background: #e3f2fd; border-left: 4px solid #1976d2; color: #1565c0; font-size: 0.82rem; padding: 8px 14px; border-radius: 6px; margin-bottom: 20px; }
.seccion-titulo { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; color: #3f51b5; border-bottom: 2px solid #e8eaf6; padding-bottom: 6px; margin-bottom: 14px; }
.resultado-card { background: linear-gradient(135deg, #e8eaf6 0%, #f5f6ff 100%); border: 1px solid #c5cae9; border-radius: 10px; padding: 16px 20px; margin-top: 8px; }
.resultado-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.resultado-final { border-top: 1px solid #c5cae9; padding-top: 10px; margin-top: 4px; }
.resultado-label { font-size: 0.85rem; color: #5c6bc0; }
.resultado-valor { font-size: 0.9rem; }
.resultado-precio { font-size: 1.4rem; font-weight: 800; color: #3f51b5; }
.resultado-nota { font-size: 0.7rem; color: #9e9e9e; margin-top: 8px; }
</style>
